
export default {
  data () {
    return {
      description: '',
      name: '',
      email: '',
      data: {
        address: [
          {
            id: 1,
            title: 'Office (Headquater)',
            info: '100/1 Vorasombat Building, Rama 9 Road Huaykwang, Bangkok,10310 Thailand'
          },
          {
            id: 2,
            title: 'Factory (Branch 1)',
            info: '111/11 Sangchuto Road, Tha Maka, Tha Maka District, Kanchanaburi, 71120 Thailand'
          },
          {
            id: 3,
            title: 'Factory (Branch 2)',
            info: '111 Phang Tru, Tha Muang District, Kanchanaburi 71110 Thailand'
          },
        ],
        contact: [
          {
            id: 4,
            icon: 'icon-email-blue',
            info: 'sales@advance-fiber.com'
          },
          {
            id: 5,
            icon: 'icon-phone-blue',
            info: '+66 2 645 1064'
          }
        ]
      }
    }
  }
}
